import { render, staticRenderFns } from "./c-table-header.vue?vue&type=template&id=36b3f1dd&scoped=true"
import script from "./c-table-header.vue?vue&type=script&lang=js"
export * from "./c-table-header.vue?vue&type=script&lang=js"
import style0 from "./c-table-header.vue?vue&type=style&index=0&id=36b3f1dd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b3f1dd",
  null
  
)

export default component.exports